import { useMemo } from 'react';
import { useIsDemo } from '@/hooks/common/useIsDemo';
import { useSelectedOrgId } from '@/hooks/common/useSelectedOrgId';
import {
  ALL_PORTFOLIO_ENTITIES,
  PERSONAL_ORG_ID,
  PORTFOLIO_ACTIVITY,
  PORTFOLIO_CONNECTED_ACCOUNTS,
  PORTFOLIO_DEAL_MAPS,
  PORTFOLIO_TRANSACTIONS,
} from '@/mockData';
import { filterByOrg } from '@/mockData/common/demoFilters';

export function usePortfolioSeedData() {
  const isDemo = useIsDemo();
  const selectedOrgId = useSelectedOrgId();
  const activeOrgId = selectedOrgId || PERSONAL_ORG_ID;

  const seedEntities = useMemo(
    () => (isDemo ? filterByOrg(ALL_PORTFOLIO_ENTITIES, activeOrgId) : []),
    [activeOrgId, isDemo],
  );
  const seedDealMap = useMemo(
    () => (isDemo ? PORTFOLIO_DEAL_MAPS[activeOrgId] ?? {} : {}),
    [activeOrgId, isDemo],
  );
  const seedTransactions = useMemo(
    () => (isDemo ? PORTFOLIO_TRANSACTIONS[activeOrgId] ?? {} : {}),
    [activeOrgId, isDemo],
  );
  const seedActivity = useMemo(
    () => (isDemo ? PORTFOLIO_ACTIVITY[activeOrgId] ?? {} : {}),
    [activeOrgId, isDemo],
  );
  const entityConnectedAccounts = useMemo(
    () => (isDemo ? PORTFOLIO_CONNECTED_ACCOUNTS[activeOrgId] ?? {} : {}),
    [activeOrgId, isDemo],
  );

  return {
    seedEntities,
    seedDealMap,
    seedTransactions,
    seedActivity,
    entityConnectedAccounts,
  };
}
